import { Autocomplete, AutocompleteChangeReason, TextField } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { BankAccountState } from '../../../store/actions/corporates';
import { RootState } from '../../../store/reducers';

interface IBankAccountAutoCompleteProps {
    filterBankAccount: string | undefined;
    setFilterBankAccount: (campaign: string | undefined) => void;
}

const BankAccountAutoComplete = ({ filterBankAccount, setFilterBankAccount }: IBankAccountAutoCompleteProps) => {
    const { t } = useTranslation();
    const bankAccountsState: BankAccountState[] | [] = useSelector((state: RootState) => state.bankAccountUser.list);
    const [bankAccountListOptions, setBankAccountListOptions] = useState<[] | { label: string; value: string }[]>([]);
    const [bankAccountsOptionSelected, setBankAccountOptionSelected] = useState<{ label: string; value: string } | null>(null);

    useEffect(() => {
        const arrayBankAccountOption: { label: string | undefined; value: string | undefined }[] = [];
        /**
         * if corporate is selected I have to list campaign owned by that corporate
         * otherwise all campaign of bank is listed
         */

        bankAccountsState?.map((bankAccount: BankAccountState) => {
            arrayBankAccountOption.push({
                label: bankAccount.contoCorrente,
                value: bankAccount.senderAccount
            });
            return arrayBankAccountOption;
        });

        setBankAccountListOptions(arrayBankAccountOption);
    }, [bankAccountsState, bankAccountListOptions]);

    useEffect(() => {
        if (!bankAccountsState) return;

        const bankAccountElement: BankAccountState | undefined = bankAccountsState?.find((bankAccount: BankAccountState) => bankAccount.senderAccount === filterBankAccount);

        setBankAccountOptionSelected(
            bankAccountElement
                ? {
                      label: bankAccountElement?.contoCorrente,
                      value: bankAccountElement?.senderAccount
                  }
                : null
        );
    }, [bankAccountsState, filterBankAccount]);

    return (
        <Autocomplete
            disablePortal
            id="combo-box-bankAccounts"
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            value={bankAccountsOptionSelected?.value}
            onInputChange={(event: SyntheticEvent<Element, Event>, value: string, reason: AutocompleteChangeReason) => {
                if (reason === 'clear') {
                    setFilterBankAccount(undefined);
                    return;
                }
            }}
            inputValue={bankAccountsOptionSelected?.label || ''}
            options={bankAccountListOptions}
            sx={{ width: '100%', minWidth: '140px' }}
            renderInput={(params) => <TextField {...params} label={t('bankAccount.label', { ns: 'common' })} InputLabelProps={{ shrink: true }} variant="standard" />}
            onChange={(event: SyntheticEvent<Element, Event>, value: { label: string; value: string } | null, _reason: AutocompleteChangeReason) => {
                setFilterBankAccount(value?.value ?? undefined);
            }}
            placeholder={t('bankAccount.placeholder', { ns: 'common' })}
        />
    );
};

export default BankAccountAutoComplete;
